// @flow
import { createURL } from '../actions';

export const DEPARTMENT_FACET = 'departments.name';
export const SUBDEPARTMENT_FACET = 'subdepartments.name';

export function subdepartmentSearchUrl(
  departmentName: string,
  subdepartmentName: string,
): string {
  const searchState: any = {
    refinementList: {
      [DEPARTMENT_FACET]: [departmentName],
      [SUBDEPARTMENT_FACET]: [subdepartmentName],
    },
  };

  return `/busca${createURL(searchState)}`;
}
